export const stepsSelector = (state) => state.steps.list;
export const hasNextStepSelector = (state) => state.steps.hasNextStep;
export const currentStepSelector = (state) => state.steps.currentStep;